// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__FzYSN","footer":"ModalUpdate_footer__2bmYS"};